import React, { FC } from "react";
import "./StepperHeader.scss";

interface StepperHeaderProps {
  steps: string[];
  activeStep: number;
}

const StepperHeader: FC<StepperHeaderProps> = ({ steps, activeStep }) => {
  return (
    <div className="stepper-container">
      <div className="stepper-wrapper">
        {steps.map((label, index) => (
          <div key={index} className="stepper-item">
            <div
              className={`stepper-circle ${
                index <= activeStep ? "active" : ""
              } ${index < activeStep ? "completed" : ""}`}
            >
              {index < activeStep ? (
                <span className="stepper-check">✓</span>
              ) : (
                <span className="stepper-number">{index + 1}</span>
              )}
            </div>
            <span
              className={`stepper-label ${
                index <= activeStep ? "active" : ""
              } ${index < activeStep ? "completed" : ""}`}
            >
              {label}
            </span>
            {index < steps.length - 1 && (
              <div
                className={`stepper-line ${
                  index < activeStep ? "completed" : ""
                } ${index === activeStep ? "active" : ""}`}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepperHeader;
